<!-- Color Picker Trigger -->
<button
  type="button"
  class="zag-color-picker__trigger"
  [attr.aria-haspopup]="'dialog'"
  [attr.aria-expanded]="isOpen()"
  [attr.aria-disabled]="disabled()"
  [disabled]="disabled()"
  (click)="toggle()"
  (focus)="onTriggerFocus()"
  (blur)="onTriggerBlur()"
>
  <span class="zag-color-picker__value" [class.zag-color-picker__value--placeholder]="!selectedColor()">
    @if (selectedColor()) {
    <span class="zag-color-picker__swatch" [style.background-color]="selectedColor()!.value"></span>
    } {{ displayText() }}
  </span>
  @if (showClearButton()) {
  <button type="button" class="zag-color-picker__clear" aria-label="Clear selection" (click)="clearSelection($event)">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
  }
  <span class="zag-color-picker__arrow" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [class.zag-color-picker__arrow--rotated]="isOpen()">
      <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </span>
</button>

<!-- Color Picker Panel (rendered in CDK overlay) -->
<ng-template #panelTemplate>
  <dialog open class="zag-color-picker__panel" aria-label="Select a color">
    <!-- Color grid -->
    <div class="zag-color-picker__grid">
      @for (color of colors(); track color.name) {
      <button
        type="button"
        class="zag-color-picker__color-button"
        [class.zag-color-picker__color-button--selected]="isSelected(color)"
        [style.background-color]="color.value"
        [attr.aria-label]="color.label"
        [attr.aria-pressed]="isSelected(color)"
        [title]="color.label"
        (click)="selectColor(color)"
      >
        @if (isSelected(color)) {
        <span class="zag-color-picker__check" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor" />
          </svg>
        </span>
        }
      </button>
      }
    </div>

    <!-- Custom color input -->
    @if (allowCustom()) {
    <div class="zag-color-picker__custom">
      <label for="custom-color-input" class="zag-color-picker__custom-label">Custom color</label>
      <div class="zag-color-picker__custom-input-wrapper">
        <input
          id="custom-color-input"
          type="text"
          class="zag-color-picker__custom-input"
          placeholder="#000000"
          [value]="customColorInput()"
          (input)="onCustomColorInput($event)"
          maxlength="7"
        />
        <button type="button" class="zag-color-picker__custom-apply" [disabled]="!isCustomColorValid()" (click)="selectCustomColor()">
          Apply
        </button>
      </div>
      @if (customColorInput() && isCustomColorValid()) {
      <div class="zag-color-picker__custom-preview" [style.background-color]="customColorInput()"></div>
      }
    </div>
    }
  </dialog>
</ng-template>
